import { put, takeLatest } from 'redux-saga/effects';
import * as actions from '@/actions';

const { SUBMIT_ORDER_REQUEST, ORDER_GET_ORDER_DETAILS_REQUEST } = actions;

function* updateEmptyError() {
  yield put(actions.updateEmptyError());
}

export default function* commonSagas() {
  yield takeLatest([ORDER_GET_ORDER_DETAILS_REQUEST, SUBMIT_ORDER_REQUEST], updateEmptyError);
}
